export const ADD_POST_REQUEST = 'ADD_POST_REQUEST';
export const ADD_POST_RESPONSE = 'ADD_POST_RESPONSE';
export const POST_REQUEST_ERROR = 'POST_REQUEST_ERROR';
export const GET_POST_REQUEST = 'GET_POST_REQUEST';
export const GET_POST_RESPONSE = 'GET_POST_RESPONSE';
export const GET_REQUEST_ERROR = 'GET_REQUEST_ERROR';
export const GET_LIST_POST_REQUEST = 'GET_LIST_POST_REQUEST';
export const GET_LIST_POST_RESPONSE = 'GET_LIST_POST_RESPONSE';
export const GET_LIST_REQUEST_ERROR = 'GET_LIST_REQUEST_ERROR';
export const DELETE_POST_REQUEST = 'DELETE_POST_REQUEST';
export const DELETE_POST_RESPONSE = 'DELETE_POST_RESPONSE';
export const DELETE_POST_ERROR = 'DELETE_POST_ERROR';
export const DUPLICATE_POST_REQUEST = 'DUPLICATE_POST_REQUEST';
export const DUPLICATE_POST_RESPONSE = 'DUPLICATE_POST_RESPONSE';
export const DUPLICATE_POST_ERROR = 'DUPLICATE_POST_ERROR';
export const UPDATE_POST_REQUEST = 'UPDATE_POST_REQUEST';
export const UPDATE_POST_RESPONSE = 'UPDATE_POST_RESPONSE';
export const PAGE_SIZE = 10;
export const UPDATE_SKIP = 'UPDATE_SKIP';
export const Update_SEARCH_VALUE = 'Update_SEARCH_VALUE';

export const GET_LIST_AUTHOR_REQUEST = 'GET_LIST_AUTHOR_REQUEST';
export const GET_LIST_AUTHOR_RESPONSE = 'GET_LIST_AUTHOR_RESPONSE';
export const GET_LIST_AUTHOR_REQUEST_ERROR = 'GET_LIST_AUTHOR_REQUEST_ERROR';

export const UPDATE_FILTER = 'UPDATE_FILTER';
export const GET_FILTER = 'GET_FILTER';

// export const VALIDATE_POST_REQUEST = 'VALIDATE_POST_REQUEST';
// export const VALIDATE_POST_RESPONSE = 'VALIDATE_POST_RESPONSE';
// export const VALIDATE_POST_ERROR = 'VALIDATE_POST_ERROR';

